import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/***************** FETCH ALL GROUP REPORT START *************** */
export const getAllGroupOfficerReport = (fetchData: any) => {
	const data = {
		GetAllGroupOfficerReportToken: fetchData,
	};
	const url = `${API_URL}getAllGroupOfficerReports`;
	return makeApiCall(url, data);
};
/***************** FETCH ALL GROUP REPORT END *************** */

/***************** FETCH ALL CENTER LIST BASED ON OFFICER START *************** */
export const getAllCenterListForOfficer = (fetchData: any) => {
	const data = {
		GetAllCenterListForOfficerToken: fetchData,
	};
	const url = `${API_URL}getAllCenterListBasedOnGroupOfficer`;
	return makeApiCall(url, data);
};
/***************** FETCH ALL CENTER LIST BASED ON OFFICER END *************** */
